import * as z from "zod/v4";

export const getSubscriptionPlans = {
  name: "getSubscriptionPlans" as const,
  input: z.object({ productId: z.string() }),
  output: z.object({
    plans: z.array(
      z.object({
        id: z.number(),
        externalPlanId: z.string(),
        planName: z.string(),
        sellingPlanId: z.string().nullish(),
        discountAmount: z.string().nullish(),
        discountType: z.string().nullish(),
        billingPolicy: z.object({
          interval: z.string(),
          intervalCount: z.number(),
        }),
        deliveryPolicy: z.object({
          interval: z.string(),
          intervalCount: z.number(),
        }),
      }),
    ),
  }),
};
